module.exports = __webpack_public_path__ + "static/img/cat_react.b5b084f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cat_react.gif
// module id = 416
// module chunks = 1